<template>
  <div id="glossary">
    <h1>リファレンスサイト</h1>

    <br />
    <br />

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">DanceMinder</div>
        <div class="md-subhead">URL：<a href="https://danceminder.com/" target=_blank>https://danceminder.com/</a></div>
      </md-card-header>
      <md-card-content>
        Set DanceだけでなくSiege of Ennisなどの様々なダンスが掲載されている。
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">DanceMinder Blog</div>
        <div class="md-subhead">URL：<a href="https://danceminder.com/blog/" target=_blank>https://danceminder.com/blog/</a></div>
      </md-card-header>
      <md-card-content>
        上記サイトのブログ。
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">Irish Set Dancing</div>
        <div class="md-subhead">URL：<a href="http://setdanceteacher.ie/" target=_blank>http://setdanceteacher.ie/</a></div>
      </md-card-header>
      <md-card-content>
        DanceMinderで目当てのセットが見つからないときはこちら。
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">Set Dancing News</div>
        <div class="md-subhead">URL：<a href="http://sets.ie/" target=_blank>http://sets.ie/</a></div>
      </md-card-header>
      <md-card-content>
        Bill Lynch氏が運営しているおそらくSet Dance界で一番のウェブサイト。ヨーロッパ各地のセットダンスクラスやケーリーの情報が掲載されている。
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">Irish Bliss</div>
        <div class="md-subhead">URL：<a href="http://irishbliss.org/" target=_blank>http://irishbliss.org/</a></div>
      </md-card-header>
      <md-card-content>
        EASY IRISH DANCEというウェブサイトを運営しているNoraさんのブログ。アイルランドのSummer Schoolの情報やセットの人気投票などが掲載されている。
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">Irish Set Dance Music Database</div>
        <div class="md-subhead">URL：<a href="http://mabula.net:8000/setmusic/" target=_blank>http://mabula.net:8000/setmusic/</a></div>
      </md-card-header>
      <md-card-content>
        バーズ(Bars)やリズムで曲を探せるサイト。「踊りたいけれど曲がない…」という時に便利。
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">SessionGO</div>
        <div class="md-subhead">URL：<a href="https://sessiongo.com/" target=_blank>https://sessiongo.com/</a></div>
      </md-card-header>
      <md-card-content>
        "SessionGOでは全国の音楽セッションの情報を検索・投稿することができます。<br/>
        また、チャットで気軽にコミュニケーションすることもできます！<br/>
        演奏する人はもちろん、お酒や美味しいパブ料理などを楽しみながら聴きたい人にも役立つでしょう！"<br/>
        <br/>
        ウェブサイトの構成が SetDancePal の構成と同じ vue.js + firebase です。とても良いサイトなのでセッション好きの方は覗いてみてください。
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">Scottish Country Dancing Dictionary</div>
        <div class="md-subhead">URL：<a href="https://www.scottish-country-dancing-dictionary.com/" target=_blank>https://www.scottish-country-dancing-dictionary.com/</a></div>
      </md-card-header>
      <md-card-content>
        スコットランドのダンスを網羅しているサイト。
      </md-card-content>
    </md-card>

    <md-divider></md-divider>

    <span class="md-caption">copyright © 2017-{{ new Date().getFullYear() }} Hiroshi Jo</span>

  </div>
</template>

<script>
// import db from '../db'

export default {
  name: 'set',
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// Reference.vue?7f3b7b90